import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "section-latest-blog py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "section-title font-weight-bold text-center mb-5" }, " Latest Blog Posts ", -1)
const _hoisted_4 = { class: "blog-cards row" }
const _hoisted_5 = { class: "col-12 col-lg-6" }
const _hoisted_6 = { class: "card rounded-0 border-0 shadow-sm mb-5" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"card-img-container position-relative\"><img class=\"card-img-top rounded-0\" src=\"/images/blog/blog-post-thumb-2.jpg\" alt=\"\"><div class=\"\n                  card-img-overlay\n                  overlay-mask overlay-logo\n                  text-center\n                  p-0\n                \"><div class=\"\n                    overlay-mask-content\n                    text-center\n                    w-100\n                    position-absolute\n                  \"><a class=\"btn btn-primary\" href=\"blog-post.html\">Read more</a></div><a class=\"overlay-mask-link position-absolute w-100 h-100\" href=\"blog-post.html\"></a></div></div>", 1)
const _hoisted_8 = { class: "card-body pb-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h4", { class: "card-title text-truncate mb-2" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "text-link",
    href: "blog-post.html"
  }, "React, Bootstrap, and Angular- The Basics")
], -1)
const _hoisted_10 = { class: "card-text" }
const _hoisted_11 = { class: "meta list-inline mb-1" }
const _hoisted_12 = { class: "list-inline-item me-3" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("June 18, 2021 ")
const _hoisted_14 = { class: "list-inline-item" }
const _hoisted_15 = /*#__PURE__*/_createVNode("a", {
  class: "text-link",
  href: "#"
}, "8 Comments", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "excerpt" }, " Blog post intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vel sapien quis nulla dictum euismod. Vivamus sed mi vitae dui iaculis venenatis... ", -1)
const _hoisted_17 = { class: "col-12 col-lg-6" }
const _hoisted_18 = { class: "card rounded-0 border-0 shadow-sm mb-5" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"card-img-container position-relative\"><img class=\"card-img-top rounded-0\" src=\"/images/blog/blog-post-thumb-3.jpg\" alt=\"\"><div class=\"\n                  card-img-overlay\n                  overlay-mask overlay-logo\n                  text-center\n                  p-0\n                \"><div class=\"\n                    overlay-mask-content\n                    text-center\n                    w-100\n                    position-absolute\n                  \"><a class=\"btn btn-primary\" href=\"blog-post.html\">Read more</a></div><a class=\"overlay-mask-link position-absolute w-100 h-100\" href=\"blog-post.html\"></a></div></div>", 1)
const _hoisted_20 = { class: "card-body pb-4" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h4", { class: "card-title text-truncate mb-2" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "text-link",
    href: "blog-post.html"
  }, "Best Practices for Code Review")
], -1)
const _hoisted_22 = { class: "card-text" }
const _hoisted_23 = { class: "meta list-inline mb-1" }
const _hoisted_24 = { class: "list-inline-item me-3" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("May 7, 2021 ")
const _hoisted_26 = { class: "list-inline-item" }
const _hoisted_27 = /*#__PURE__*/_createVNode("a", {
  class: "text-link",
  href: "#"
}, "23 Comments", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "excerpt" }, " Blog post intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vel sapien quis nulla dictum euismod. Vivamus sed mi vitae dui iaculis venenatis... ", -1)
const _hoisted_29 = { class: "col-12 col-lg-6" }
const _hoisted_30 = { class: "card rounded-0 border-0 shadow-sm mb-5" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"card-img-container position-relative\"><img class=\"card-img-top rounded-0\" src=\"/images/blog/blog-post-thumb-4.jpg\" alt=\"\"><div class=\"\n                  card-img-overlay\n                  overlay-mask overlay-logo\n                  text-center\n                  p-0\n                \"><div class=\"\n                    overlay-mask-content\n                    text-center\n                    w-100\n                    position-absolute\n                  \"><a class=\"btn btn-primary\" href=\"blog-post.html\">Read more</a></div><a class=\"overlay-mask-link position-absolute w-100 h-100\" href=\"blog-post.html\"></a></div></div>", 1)
const _hoisted_32 = { class: "card-body pb-4" }
const _hoisted_33 = /*#__PURE__*/_createVNode("h4", { class: "card-title text-truncate mb-2" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "text-link",
    href: "blog-post.html"
  }, "Learn React Components")
], -1)
const _hoisted_34 = { class: "card-text" }
const _hoisted_35 = { class: "meta list-inline mb-1" }
const _hoisted_36 = { class: "list-inline-item me-3" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Apr 25, 2021 ")
const _hoisted_38 = { class: "list-inline-item" }
const _hoisted_39 = /*#__PURE__*/_createVNode("a", {
  class: "text-link",
  href: "#"
}, "18 Comments", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "excerpt" }, " Blog post intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vel sapien quis nulla dictum euismod. Vivamus sed mi vitae dui iaculis venenatis... ", -1)
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("View all posts")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlogPostThumbnail = _resolveComponent("BlogPostThumbnail")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.blogPosts, (post) => {
          return (_openBlock(), _createBlock("div", {
            key: post.slug,
            class: "col-12 col-lg-6"
          }, [
            _createVNode(_component_BlogPostThumbnail, { "blog-post": post }, null, 8, ["blog-post"])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _createVNode("ul", _hoisted_11, [
                  _createVNode("li", _hoisted_12, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'clock'],
                      class: "me-2"
                    }),
                    _hoisted_13
                  ]),
                  _createVNode("li", _hoisted_14, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "comment",
                      class: "me-2"
                    }),
                    _hoisted_15
                  ])
                ]),
                _hoisted_16
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode("div", _hoisted_22, [
                _createVNode("ul", _hoisted_23, [
                  _createVNode("li", _hoisted_24, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'clock'],
                      class: "me-2"
                    }),
                    _hoisted_25
                  ]),
                  _createVNode("li", _hoisted_26, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "comment",
                      class: "me-2"
                    }),
                    _hoisted_27
                  ])
                ]),
                _hoisted_28
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode("div", _hoisted_34, [
                _createVNode("ul", _hoisted_35, [
                  _createVNode("li", _hoisted_36, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'clock'],
                      class: "me-2"
                    }),
                    _hoisted_37
                  ]),
                  _createVNode("li", _hoisted_38, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "comment",
                      class: "me-2"
                    }),
                    _hoisted_39
                  ])
                ]),
                _hoisted_40
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_41, [
      _createVNode(_component_router_link, {
        class: "btn btn-primary",
        to: { name: 'blog' }
      }, {
        default: _withCtx(() => [
          _hoisted_42
        ]),
        _: 1
      })
    ])
  ]))
}